import { createMuiTheme } from '@material-ui/core/styles';
import {
  PEACH,
  LIGHT_SOY,
  MEDIUM_SOY,
  SOY,
  PLUM,
  WHITE,
  MEDIUM_TOFU,
  ERROR
} from 'base/constants/colors';
import overrides from './overrides';
import { FONT_NAMES } from './font';
import {
  BOX_SHADOW_CARD_NORMAL,
  BOX_SHADOW_CARD_SELECTED
} from 'base/constants/shadows';
const HEADING_LINE_HEIGHT = 1.25;
const headingStyles = {
  fontFamily: FONT_NAMES.med,
  fontSize: 20,
  letterSpacing: 0.25,
  lineHeight: HEADING_LINE_HEIGHT,
  textTransform: 'none',
  color: SOY
};

const createPalette = (
  primaryColor = PEACH,
  secondaryColor = PLUM,
  bodyColor = WHITE
) => ({
  palette: {
    primary: {
      main: primaryColor,
      contrastText: bodyColor
    },
    secondary: {
      main: secondaryColor
    },
    text: {
      primary: SOY,
      secondary: MEDIUM_SOY,
      disabled: LIGHT_SOY,
      hint: secondaryColor
    },
    background: {
      default: WHITE,
      secondary: 'rgba(0,0,0,0.5)'
    },
    borders: {
      primary: MEDIUM_TOFU
    },
    action: {
      disabledBackground: primaryColor
    },
    error: {
      main: ERROR
    }
  }
});

const baseTheme = {
  overrides,
  props: {
    MuiButtonBase: {
      disableRipple: true
    },
    MuiList: {
      disablePadding: true
    },
    MuiListItem: {
      disableGutters: true
    }
  },
  boxShadows: {
    MuiCard: {
      base: BOX_SHADOW_CARD_NORMAL,
      selected: BOX_SHADOW_CARD_SELECTED
    }
  },
  typography: {
    fontFamily: [FONT_NAMES.reg, 'Helvetica Neue', 'Arial', 'sans-serif'].join(
      ','
    ),
    body1: {
      fontSize: 14,
      color: MEDIUM_SOY
    },
    body2: { color: LIGHT_SOY },
    caption: {
      fontSize: 12
    },
    h1: headingStyles,
    h2: headingStyles,

    h3: {
      color: MEDIUM_SOY,
      textTransform: 'uppercase',
      fontSize: 12,
      textAlign: 'center',
      letterSpacing: 2,
      lineHeight: HEADING_LINE_HEIGHT,
      fontFamily: FONT_NAMES.med
    },
    h5: {
      textTransform: 'uppercase',
      color: MEDIUM_SOY,
      fontSize: 12,
      letterSpacing: 2,
      lineHeight: HEADING_LINE_HEIGHT,
      fontFamily: FONT_NAMES.med
    },
    // heading 2
    h4: {
      fontSize: 16,
      color: SOY,
      letterSpacing: 0.25,
      fontFamily: FONT_NAMES.med
    },
    subtitle1: {
      color: WHITE,
      fontSize: 14,
      lineHeight: 1.43
    },
    subtitle2: {
      color: WHITE,
      fontSize: 14,
      marginBottom: '4px',
      lineHeight: 1.43
    }
  }
};

export const createCustomColorTheme = ({
  primaryColor,
  secondaryColor,
  bodyColor
}) => {
  return createMuiTheme({
    ...createPalette(primaryColor, secondaryColor, bodyColor),
    ...baseTheme
  });
};
